import { Link } from 'gatsby';
import styled, { css } from 'styled-components';

import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const BasicTileWrapper = styled(Link)`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  color: ${colors.white};
  border-radius: 12px;
  box-sizing: border-box;
  z-index: 0;
  position: relative;

  &::before {
    position: absolute;
    content: '';
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background: ${colors.verseCardColor};
  }

  &::after {
    content: '';
    z-index: -2;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
    position: absolute;
    border-radius: 12px;

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.4);

    background: radial-gradient(
      62.81% 328.16% at 50% 50%,
      #26303f 0%,
      rgba(59, 69, 90, 0) 100%
    );
  }
`;

export const TileWrapper = styled.a`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  max-height: 160px;
  color: ${colors.white};
  border-radius: 12px;
  box-sizing: border-box;
  z-index: 0;
  position: relative;

  &::before {
    position: absolute;
    content: '';
    z-index: -1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 12px;
    background: linear-gradient(0deg, #0f1823, #0f1823),
      radial-gradient(
        117.51% 1182.96% at 50% 50%,
        #273953 0%,
        rgba(0, 0, 0, 0) 100%
      );
  }

  &::after {
    content: '';
    z-index: -2;
    left: -1px;
    right: -1px;
    top: -1px;
    bottom: -1px;
    position: absolute;
    border-radius: 12px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.4);
    background: radial-gradient(
      62.81% 328.16% at 50% 50%,
      #26303f 0%,
      rgba(59, 69, 90, 0) 100%
    );
  }
`;

export const Spacer = styled.div`
  height: 53px;
`;

export const Icon = styled.div`
  width: 20px;
  height: 20px;
  color: ${colors.verseBlue};
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Subtitle = styled.div<{ exclusive?: boolean }>`
  ${({ exclusive }) => css`
    font-size: 12px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    color: ${exclusive ? colors.exclusive100 : colors.verseBlue};
    text-transform: uppercase;
  `}
`;

export const Title = styled.div`
  font-family: Saeada;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  color: ${colors.shade80};

  a {
    color: ${colors.verseBlue};
    font-weight: 600;
  }
`;

export const Badge = styled.div`
  display: flex;
  padding: 7px 11px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  border-radius: 0px 12px 0px 6px;
  background: ${colors.shade30};
  color: ${colors.shade90};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  position: absolute;
  right: 0px;
  top: 0;
  z-index: 1;
`;

export const NewBadge = styled.span`
  box-sizing: border-box;
  position: absolute;
  top: 7px;
  right: 11px;
  display: inline-flex;
  width: auto;
  height: 18px;

  justify-content: center;
  align-items: center;
  line-height: auto;
  background: linear-gradient(93.32deg, #0085ff 0%, #db00ff 100%);
  border-radius: 3px;

  padding: 2px 4px;

  text-transform: uppercase;
  font-size: 12px;
  line-height: normal;
  font-weight: 700;
`;
